import { useEffect, useState } from 'react';

const NAV_LINKS = [
  { label: '今日瓜榜', href: '#rank' },
  { label: '猛料速递', href: '#feed' },
  { label: '劲爆时间轴', href: '#timeline' },
  { label: '压轴盘点', href: '#featured' },
  { label: '热评围观', href: '#buzz' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/90 backdrop-blur-md border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-xl" />
          </span>
          <span
            className={`font-heading text-2xl font-black tracking-tight ${scrolled ? 'text-foreground-950' : 'text-background-50'}`}
          >
            黑料王
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                scrolled
                  ? 'text-foreground-700 hover:bg-background-100 hover:text-primary-700'
                  : 'text-background-100 hover:bg-background-50/10 hover:text-background-50'
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <button
            type="button"
            aria-label="搜索"
            className={`flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border transition-colors ${
              scrolled
                ? 'border-background-200 text-foreground-700 hover:bg-background-100'
                : 'border-background-50/30 text-background-100 hover:bg-background-50/10'
            }`}
          >
            <i className="ri-search-line text-lg" />
          </button>
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:block"
          >
            订阅猛料
          </a>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setMobileOpen((v) => !v)}
            className={`flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border md:hidden ${
              scrolled
                ? 'border-background-200 text-foreground-700'
                : 'border-background-50/30 text-background-100'
            }`}
          >
            <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className="block rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#subscribe"
            onClick={() => setMobileOpen(false)}
            className="mt-2 block rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-semibold text-background-50"
          >
            订阅猛料
          </a>
        </nav>
      )}
    </header>
  );
}